import React, {Component} from 'react'
import {connect} from 'react-redux'
import {
  FJMediaAction,
  FJModalAction,
  FJPreviewAction,
  FJRecordingAction, FJStockVideoAction,
} from "../../../redux/action/FJRoot.action";

import FJMediaContainer from 'fj-components/FJMediaContainer';
import FJNoMedia from "../view/FJNoMedia";
import FJActionConstant from "../../../constant/FJActionConstant";
import FJUtil from "../../../util/FJUtil";
import FJMediaHead from '../view/FJMediaHead';
import styles from '../view/css/FJResourcesMediaContainer.module.less';
import FJLinkPromptContainer from "./FJLinkPromptContainer";
import FJMedia from "../../../store/FJMedia";
import deleteSvg from "../../../icon/delete.svg";
import mediaRelink from "../../../icon/mediaRelink.svg";
import $ from 'jquery'
import FJLocalStore from "../../../store/FJLocalStore";
import FJPanelAnimation from '../../../common/component/FJPanelAnimation/FJPanelAnimation'
import NoMediaSvg from '../../../icon/NoMedia.svg'
import FJViewConstant from "../../../constant/FJViewConstant";

class FJResourcesMediaContainer extends Component {

  /**
   * @description 切换筛选资源类型
   * @param type
   */
  updateFiltrateMediaTypeFun = (type) => {
    this.props.updateFiltrateMedia && this.props.updateFiltrateMedia(type)
    this.props.cutScrollAction && this.props.cutScrollAction(true);
  }

  /**
   * @description 拖动上传到指定区域触发
   * @param e
   * @private
   */
  _onDragOver = (e) => {
    window.RC.isFJDragging = true;
    e.dataTransfer.dropEffect = window.RC.hasModal ? 'none' : 'drop';
    this.props.changeDragMode(FJActionConstant.DRAG_FILE_MODE_RESOURCE);
  };

  /**
   * @description 拖动上传到离开指定区域触发
   * @private
   */
  _onDragLeave = (e) => {
    window.RC.isFJDragging = false;
    if (this.timer) {
      clearTimeout(this.timer);
    }
    e.preventDefault();
    e.stopPropagation();
    this.timer = setTimeout(() => {
      if (!window.RC.isFJDragging) {
        this.props.changeDragMode(null);
      }
    }, 100);
  };

  /**
   * @description 拖动上传到指定区域放开鼠标 触发
   * @param e
   * @private
   */
  _onDrop = (e) => {
    window.RC.isFJDragging = false;
    this.props.changeDragMode(null);
    FJUtil.onFileDrop(e, {
      ...this.props, ...{
        type: ['image', 'video', 'audio']
      }
    });
  };

  /**
   * @description 拖动资源库文件
   * @param e
   * @param data
   * @param callback
   * @private
   */
  _onMediaDrag = (e, data, callback) => {
    this.props.onMediaDrag(e, data, callback, this._getDragNodeInTimeLine);
  };

  /**
   * @description 得到拖动background到时间轴的样式
   * @param selfRect
   * @param dragInfo
   * @returns {HTMLDivElement}
   * @private
   */
  _getDragNodeInTimeLine = (selfRect, dragInfo) => {
    let node = document.createElement('div');

    let url = dragInfo.getUrl;

    $(node).addClass(styles.active);
    $(node).addClass(styles.drag_other_img);

    let backgroundColor;
    let backgroundImage = 'url(' + url + ')';
    switch (dragInfo.type) {
      case 'AUDIO':
        backgroundColor = '#7F809B';
        break;
      default:
        backgroundColor = 'auto';
    }

    $(node).css({
      width: selfRect.width,
      height: selfRect.height,
      backgroundColor: backgroundColor,
      backgroundPosition: this.props.type === 'AUDIO' ? 'center' : 'auto',
      backgroundImage: backgroundImage,
      borderColor: '#FF822C',
      borderRadius: '4px'
    });
    return node;
  };

  _allTooltip = () => {
    FJUtil.allTooltip('u-tooltip-bottom', 'bottom');
  };

  _oneTooltip = (ele) => {
    FJUtil.oneTooltip(ele, 'bottom');
  };

  _render = () => {
    let {
      mediaList,
      chooseMediaIdList = [],
      isShow,
      dragFileMode,
      screenClick,
      webCamClick,
      batchDeleteMedia,
      recordClick,
      onDataChange,
      mediaOverSize,
      mediaOverNum,
      mediaNotSupport,
      stop,
      isTopScroll,
      filtrateMediaType,
      openStockModel
    } = this.props;

    let active = mediaList.find(media => media.status === FJMedia.MediaStatus().LINK);
    let NoFiltrateMediaText = FJLocalStore._('no_filtrate_media');
    const classes = {
      noMediaClasses: {
        noMediaBox: styles.no_media,
        horizontalBorder: styles.horizontal_border,
        verticalBorder: styles.vertical_border,
        uploadBox: styles.upload_box,
        dragMaskBox: styles.drag_mask_box
      },
      noFiltrateMediaClass: {
        filtrateBox: styles.filtrate_box
      },
      mediaClasses: {
        mediaBox: active ? styles.link_media : styles.media,
        mediaListBox: active ? styles.relink_media : styles.media_list,
        mediaListInnerBox: styles.media_inner,
        dragMaskBox: styles.drag_in_media,
        filtrateInnerBox: styles.filtrateInnerBox
      },
      itemClasses: {
        resourceItemActive: styles.active,
        inner: styles.item_inner,
        addBtnBox: styles.add_box,
        deleteBtnBox: styles.delete_box,
        addBtn: styles.add,
        deleteBtn: styles.delete,
        name: styles.name,
        link: styles.link,
        refresh: styles.refresh_img,
        cloudProgressInner: styles.cloud_inner
      }
    };
    this._resourceViewInfo = this._resourceViewInfo || {
      width: 140,
      height: 80,
      space: 12,
      marginBottom: 16,
    };
    this._audioWaveStyle = this._audioWaveStyle || {background: '#7F809B'}
    this._config = this._config || {
      hasDeleteBtn: true,
      hasAddBtn: true,
      hasName: true,
      linkIcon: mediaRelink,
      deleteIcon: deleteSvg,
      addIconToolTip: FJLocalStore._('add-to-timeline'),
      enableFiltrate: true,
      itemConfig: {
        dragBackground: '#DEDFE3',
        audioDragBackground: '#7F809B'
      },
      audioConfig: {
        waveColor: '#A5A6B9',
        progressColor: '#A5A6B9',
        cursorColor: '#A5A6B9',
        interact: false
      },
      hasDragChange: true,
      opacityValue: .8
    };
    this._action = this._action || {
      linkClick: this.props.linkClick,
      reloadAction: this.props.onRetry,
      onHandleClick: this.props.onHandleClick,
      onDeleteClick: this.props.onDeleteClick,
      onMediaDrag: this._onMediaDrag,
      onAddClick: this.props.onAddClick,
      onDragOver: this._onDragOver,
      onDrop: this._onDrop,
      onDragLeave: this._onDragLeave,
      doCancelChoose: this.props.doCancelChoose
    };
    this._callback = this._callback || {
      allTooltip: this._allTooltip,
      oneTooltip: this._oneTooltip
    };
    switch (filtrateMediaType) {
      case 'video':
        NoFiltrateMediaText = NoFiltrateMediaText.replace('xxx', FJLocalStore._('videos').toLowerCase());
        break;
      case 'image':
        NoFiltrateMediaText = NoFiltrateMediaText.replace('xxx', FJLocalStore._('photos').toLowerCase());
        break;
      case 'audio':
        NoFiltrateMediaText = NoFiltrateMediaText.replace('xxx', FJLocalStore._('audio').toLowerCase());
        break;
      default:
    }
    return (
      <>
        <FJMediaHead recordClick={recordClick}
                     batchDeleteMedia={batchDeleteMedia}
                     onDataChange={onDataChange}
                     mediaOverSize={mediaOverSize}
                     mediaOverNum={mediaOverNum}
                     mediaNotSupport={mediaNotSupport}
                     chooseMediaIdList={chooseMediaIdList}
                     uploadOnClick={stop}
                     screenClick={screenClick}
                     webCamClick={webCamClick}
                     isShow={isShow}
                     openStockModal={openStockModel}
        />
        <FJLinkPromptContainer active={active && isShow}/>
        <FJMediaContainer isShow={isShow}
                          mediaList={mediaList}
                          chooseMediaIdList={chooseMediaIdList}
                          FJNoMediaContent={FJNoMedia}
                          dragFileMode={dragFileMode}
                          classes={classes}
                          config={this._config}
                          action={this._action}
                          resourceViewInfo={this._resourceViewInfo}
                          callback={this._callback}
                          filtrateMediaType={filtrateMediaType}
                          NoFiltrateMediaText={NoFiltrateMediaText}
                          NoFiltrateMediaIcon={NoMediaSvg}
                          isTopScroll={isTopScroll}
                          audioWaveStyle={this._audioWaveStyle}
        />
      </>
    );
  };

  render() {
    let {isShow, direction} = this.props;
    return (
      <FJPanelAnimation active={isShow} direction={direction} render={this._render} />
    )
  }
}

const mapStateToProps = function (state) {
  return {
    mediaList: state.media.mediaList,
    chooseMediaIdList: state.media.chooseMediaIdList,
    dragFileMode: state.media.dragFileMode,
    direction: state.resource.direction,
    isTopScroll: state.media.isTopScroll,
    filtrateMediaType: state.media.filtrateMediaType
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    onRetry: function (data) {
      dispatch(FJMediaAction.retryMediaAction(data.id));
    },
    batchDeleteMedia: function () {
      dispatch(FJMediaAction.batchDeleteMediaAction());
    },
    onDataChange: function (files) {
      dispatch(FJMediaAction.addLocalMediaAction(files));
    },
    doCancelChoose: function () {
      dispatch(FJMediaAction.selectMediaAction('', 2, 0));
    },
    screenClick: function () {
      dispatch(FJPreviewAction.setVideoPauseAction());
      dispatch(FJRecordingAction.startRecordScreenAction());
    },
    webCamClick: function () {
      dispatch(FJPreviewAction.setVideoPauseAction());
      dispatch(FJRecordingAction.startRecordWebCamAction());
    },
    recordClick: function () {
      dispatch(FJPreviewAction.setVideoPauseAction());
      dispatch(FJModalAction.setIsShowReRecordFromModalAction(true));
    },
    mediaOverSize: function () {
      dispatch(FJMediaAction.mediaOverSizeAction());
    },
    mediaOverNum: function (callback) {
      dispatch(FJMediaAction.mediaOverNumAction(callback));
    },
    mediaNotSupport: function () {
      dispatch(FJMediaAction.mediaNotSupportAction());
    },
    changeDragMode: function (data) {
      dispatch(FJMediaAction.changeDragModeAction(data));
    },
    stop: function () {
      dispatch(FJPreviewAction.setVideoPauseAction());
    },
    updateFiltrateMedia: function (type) {
      dispatch(FJMediaAction.updateFiltrateMediaTypeAction(type));
    },
    onAddClick: function (id, type) {
      dispatch(FJMediaAction.addToTimeLineAction(type, FJMedia.MediaFromType().LOCAL, id));
    },
    onDeleteClick: function (id) {
      dispatch(FJMediaAction.deleteMediaAction(id));
    },
    onHandleClick: function (id, type, rate) {
      dispatch(FJMediaAction.selectMediaAction(id, type, rate));
    },
    linkClick: function () {
      dispatch(FJMediaAction.openLinkModalByUser());
    },
    cutScrollAction: function (boolean) {
      dispatch(FJMediaAction.cutScrollAction(boolean))
    },
    openStockModel: function (type) {
      switch (type) {
        case FJViewConstant.STOCK_VIDEO_VIDEO:
          FJUtil.ealog('timeline_stock_media_button_click', {type: 'video'});
          break;
        case FJViewConstant.STOCK_VIDEO_MUSIC:
          FJUtil.ealog('timeline_stock_media_button_click', {type: 'audio'});
          break;
        case FJViewConstant.STOCK_VIDEO_PHOTO:
          FJUtil.ealog('timeline_stock_media_button_click', {type: 'photo'});
          break;
        default:
      }
      dispatch(FJStockVideoAction.setActiveOptionAction(type))
      dispatch(FJStockVideoAction.showStockVideoPanelAction())
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJResourcesMediaContainer);
